module.exports = __webpack_public_path__ + "img/3.9ed844f4.jpg";